import { Routes, Navigate, Route } from "react-router-dom"
import routes from "../routes";
import routespages from "../route-pages";
import {useSelector} from "react-redux";
import Clouding from "../layouts/clouding";

export const PanelRoutes = () => {
    const { roles } = useSelector(state=> state.auth);

    const getRoutes = (allRoutes) =>
        allRoutes.map((route) => {
            if (route.collapse) {
                return getRoutes(route.collapse);
            }

            if (route.route) {
                const attachRoute = roles.filter (element => route.role.includes(element) );
                if(attachRoute){
                    return <Route exact path={route.route} element={route.component} key={route.key} />;
                }
            }

            return null;
        });

    return (
        <Routes>
            { getRoutes(routes) }
            { getRoutes(routespages) }
            <Route exact path="viewer/:uuid" element={ <Clouding /> } key="viewer"  />
            <Route path="*" element={<Navigate to="/dashboard" />} />
        </Routes>
    )
}